import { castArray } from 'lodash';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable, Inject } from '@angular/core';
import {
  Router,
  UrlTree,
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
} from '@angular/router';

import { SnCurrentOrganization } from '@lib/auth/services/current-organization.service';

import { ISnAbilityConfig } from '../interfaces';
import { SN_ABILITY_CONFIG } from '../providers';
import { SnAbilityService } from '../services';

@Injectable()
export class SnAbilityGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly _router: Router,
    private readonly _ability: SnAbilityService,
    private _currentOrganization: SnCurrentOrganization,
    @Inject(SN_ABILITY_CONFIG) private readonly _config: ISnAbilityConfig,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return forkJoin([this._ability.loadPermissions(), this._currentOrganization.getProfile()]).pipe(
      map(() => this.canActivateChild(route)),
    );
  }

  public canActivateChild(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (route.data && route.data.permissions) {
      const permissions = castArray(route.data.permissions);

      if (!this._ability.can(...permissions)) {
        return this._getRedirectForbiddenTo();
      }
    }

    if (route.data && route.data.enabledIntegrations) {
      const integrationsEnabled = route.data.enabledIntegrations.every((item) =>
        this._currentOrganization.enabledIntegrations?.includes(item),
      );

      if (!integrationsEnabled) {
        return this._getRedirectForbiddenTo();
      }
    }

    return true;
  }

  private _getRedirectForbiddenTo(): UrlTree {
    return this._router.parseUrl(this._config.redirectForbiddenTo);
  }
}
